// extracted by mini-css-extract-plugin
export default {"header":"Information_header__2OoOy","btn":"Information_btn__0M229"};